module.exports = __webpack_public_path__ + "img/signup-group-3.ce4d598a.png";